// extracted by mini-css-extract-plugin
export default {"contact-container":"styles_contact-container__Y6Kjf","link":"styles_link__bhoNJ","image":"styles_image__tpYB-"};